'use client'

import styled from '@emotion/styled'
import ShieldIcon from '@mui/icons-material/Shield'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import Typography from '@mui/material/Typography'
import { motion } from 'framer-motion'

const Section = styled.section`
  padding: 96px 0;
  background: linear-gradient(135deg, #0a1929 0%, #0f2942 50%, #0a1929 100%);
  position: relative;
  overflow: hidden;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(90deg, transparent, #27b1c6, transparent);
  }

  &::before {
    content: '';
    position: absolute;
    bottom: 4px;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(
      90deg,
      transparent,
      rgba(39, 177, 198, 0.5),
      transparent
    );
  }
`

export default function BlockchainTransparency() {
  return (
    <Section>
      {/* Top gradient fade */}
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          background: 'linear-gradient(180deg, rgba(39,177,198,0.05), transparent)',
          pointerEvents: 'none',
        }}
      />

      <Container maxWidth='lg' sx={{ position: 'relative', zIndex: 1 }}>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <Box sx={{ maxWidth: 900, mx: 'auto' }}>
            <motion.div
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
              style={{ display: 'flex', justifyContent: 'center', marginBottom: 32 }}
            >
              <Box
                sx={{
                  width: { xs: 64, sm: 80 },
                  height: { xs: 64, sm: 80 },
                  borderRadius: '50%',
                  background: 'rgba(39, 177, 198, 0.2)',
                  border: '1px solid rgba(39, 177, 198, 0.3)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <ShieldIcon
                  sx={{ fontSize: { xs: 32, sm: 40 }, color: '#27b1c6' }}
                />
              </Box>
            </motion.div>

            <Typography
              variant='h3'
              sx={{
                textAlign: 'center',
                fontWeight: 700,
                color: 'white',
                mb: 4,
              }}
            >
              Truth in Blockchain Data
            </Typography>

            <Typography
              sx={{
                textAlign: 'center',
                fontSize: { xs: '1.125rem', lg: '1.375rem' },
                color: 'rgba(255,255,255,0.7)',
                lineHeight: 1.7,
                mb: 3,
              }}
            >
              Block-level on-chain data cannot lie. Our predictive models leverage
              this immutable transparency to avoid market manipulation and make
              decisions based on verifiable, tamper-proof information that
              traditional markets simply cannot provide.
            </Typography>

            <Typography
              sx={{
                textAlign: 'center',
                fontSize: '1rem',
                color: 'rgba(255,255,255,0.45)',
              }}
            >
              Every transaction, every network state, every market movement is
              permanently recorded and instantly accessible, enabling unprecedented
              accuracy in pattern recognition and trend analysis.
            </Typography>
          </Box>
        </motion.div>
      </Container>
    </Section>
  )
}
